import React, { useState, useEffect } from 'react';
import Hero from './Hero/Hero'
import Navbar from './Navbar/Navbar'
import Services from './Services/Services'
//import Hours from './Hours/Hours'

import './Home.css'

const defaultContent = {
    hero: {
        title: 'Welcome to The Nail Lab',
        description: [
            'Your Sanctuary for Exquisite Nail Care and Wellness.',
            'We are dedicated to providing you with top-notch nail care and a relaxing and luxurious experience.'
        ],
        cta: {
            label: 'Book Now',
            href: '/appointment'
        },
        theme: {
            name: 'winter',
            effects: {
                snow: false,
                snowman: false
            }
        },
        snowman: {
            href: 'https://nail-labs.square.site/',
            ariaLabel: 'Click snowman for inspo!'
        }
    },
    services: {
        heading: 'Indulge in Timeless Elegance',
        intro: [
            "Whether you're looking for a classic manicure, a trendy nail design, or a rejuvenating pedicure, we've got you covered.",
            'We use high-quality products and follow strict hygiene standards to ensure that your safety and satisfaction are our top priorities.'
        ],
        cards: [
            {
                title: 'Nail Care',
                description: [
                    'Our team of skilled technicians is passionate about',
                    'creating beautiful and healthy nails.'
                ]
            }
        ]
    }
};

const mergeContent = (baseContent, incomingContent) => {
    if (!incomingContent) {
        return baseContent;
    }

    return {
        ...baseContent,
        ...incomingContent,
        hero: {
            ...baseContent.hero,
            ...incomingContent.hero,
            cta: {
                ...baseContent.hero.cta,
                ...incomingContent?.hero?.cta
            },
            theme: {
                ...baseContent.hero.theme,
                ...incomingContent?.hero?.theme,
                effects: {
                    ...baseContent.hero.theme.effects,
                    ...incomingContent?.hero?.theme?.effects
                }
            },
            snowman: {
                ...baseContent.hero.snowman,
                ...incomingContent?.hero?.snowman
            }
        },
        services: {
            ...baseContent.services,
            ...incomingContent.services
        }
    };
};

const Home = () => {
    const [content, setContent] = useState(defaultContent);

    useEffect(() => {
        let isMounted = true;

        fetch(`${process.env.PUBLIC_URL}/content/home.json`)
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (isMounted && data) {
                    setContent((current) => mergeContent(current, data));
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        const shouldSnow = content?.hero?.theme?.effects?.snow;
        if (!shouldSnow) {
            return undefined;
        }

        const createSnowflakes = (count) => {
            const container = document.createElement('div');
            container.className = 'snow-container';
            const snowContent = ['❄', '❅', '❆'];
            
            for (let i = 0; i < count; i++) {
                const snowflake = document.createElement('div');
                snowflake.className = 'snowflake';
                snowflake.style.left = `${Math.random() * 100}%`;
                snowflake.style.animationDelay = `${Math.random() * 10}s`;
                snowflake.style.opacity = Math.random();
                snowflake.innerHTML = snowContent[Math.floor(Math.random() * snowContent.length)];
                container.appendChild(snowflake);
            }
            
            document.body.appendChild(container);
        };

        createSnowflakes(30);

        // Cleanup function
        return () => {
            const container = document.querySelector('.snow-container');
            if (container) {
                container.remove();
            }
        };
    }, [content?.hero?.theme?.effects?.snow]);
    return (
        <div>
            <Navbar/>
            <Hero
                title={content.hero.title}
                description={content.hero.description}
                cta={content.hero.cta}
                theme={content.hero.theme}
                snowman={content.hero.snowman}
            />
            <Services
                heading={content.services.heading}
                intro={content.services.intro}
                cards={content.services.cards}
            />
        </div>
    )
}

export default Home
